// extracted by mini-css-extract-plugin
module.exports = {"user-link":"_2yALE","userLink":"_2yALE","link-banned":"vUnJk","linkBanned":"vUnJk"};